
const FileIconLarge = () => {
    return (
        <svg width="36" height="37" viewBox="0 0 36 37" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect y="0.5" width="36" height="36" rx="18" fill="#D1E9FF" />
            <g clipPath="url(#clip0_1542_850)">
                <path d="M19.667 11V14.3333C19.667 14.5543 19.7548 14.7663 19.9111 14.9226C20.0674 15.0789 20.2793 15.1667 20.5003 15.1667H23.8337" stroke="#1849A9" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M22.167 26H13.8337C13.3916 26 12.9677 25.8244 12.6551 25.5118C12.3426 25.1993 12.167 24.7754 12.167 24.3333V12.6667C12.167 12.2246 12.3426 11.8007 12.6551 11.4882C12.9677 11.1756 13.3916 11 13.8337 11H19.667L23.8337 15.1667V24.3333C23.8337 24.7754 23.6581 25.1993 23.3455 25.5118C23.0329 25.8244 22.609 26 22.167 26Z" stroke="#1849A9" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.5 16H16.3333" stroke="#1849A9" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.5 19.3333H20.5" stroke="#1849A9" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M15.5 22.6667H20.5" stroke="#1849A9" strokeWidth="1.16667" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1542_850">
                    <rect width="20" height="20" fill="white" transform="translate(8 8.5)" />
                </clipPath>
            </defs>
        </svg>

    )
}

export default FileIconLarge